import React, { useEffect, useState } from 'react';
import { userRequest } from '../../../requestMethod';
import { useDispatch, useSelector } from 'react-redux';
import { validateRequired } from '../../../formValidation';
import Popup from '../../../global/Popup';
import { getProducts } from '../../../redux/apiCalls';
import { addSectionFailure, addSectionStart, addSectionSuccess } from '../../../redux/customSectionRedux';
import CircleLoader from '../../../components/circleLoader/CircleLoader';
import { uploadProductImageToSpace } from '../../../config';
import { addMilestoneFailure, addMilestoneStart, addMilestoneSuccess } from '../../../redux/milestoneRedux';

const NewMilestone = () => {

    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(false);
    const [titleErrorMessage, setTitleErrorMessage] = useState('');
    const [image, setImage] = useState(null);
    const [description, setDescription] = useState("null");
    const [isActive, setIsActive] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [discountTypeError, setDiscountTypeError] = useState(false);
    const [discountTypeErrorMessage, setDiscountTypeErrorMessage] = useState('');
    const [activePopup, setActivePopup] = useState(false);
    const [popupText, setPopuptext] = useState('');
    const [popupStatus, setPopupStatus] = useState(true);
    const [activeLoader, setActiveLoader] = useState(false);
    const [loaderText, setLoaderText] = useState("");


    const dispatch = useDispatch();

    useEffect(() => {
        getProducts(dispatch)
    }, [dispatch]);

    const handleStatusChange = (e) => {
        // Handle the change of the "For Specific Product" dropdown
        const status = e.target.value;
        // Do something with the selected status (true or false)
    };


    const handleTitleChange = (event) => {
        setTitle(event.target.value);
    };

    const addMilestone = async (dispatch, milestone) => {
        dispatch(addMilestoneStart());
        try {
            const res = await userRequest.post('/milestone/create', milestone);
            if (res.status === 200) {
                setError(false);
                // setSuccess(true);
                // setSuccessMessage("Milestone has been added!");
                setActivePopup(true)
                setPopuptext("Milestone has been added.");
                setPopupStatus(true);
                setTitle('');
                setActiveLoader(false)

            }
            dispatch(addMilestoneSuccess(res.data));
        } catch (error) {
            dispatch(addMilestoneFailure());
            setActiveLoader(false)
            if (error.response.status === 409) {
                setTitleError(true);
                setTitleErrorMessage(error.response.data);
            }

            else {
                setActivePopup(true)
                setPopuptext(error.response.data);
                setPopupStatus(false);
            }
        }
    };

    // Validate function for form validation start=======
    const [errors, setErrors] = useState({});
    const validateForm = () => {
        let formIsValid = true;
        const newErrors = {};

        const titleValidErr = validateRequired(title);

        if (titleValidErr) {
            formIsValid = false;
            newErrors.title = titleValidErr;
        }


        setErrors(newErrors);
        return formIsValid;
    }
    // Validate function for form validation end======

    const handleSection = async () => {
        // setDiscountTypeError(false);
        // setSuccess(false);
        setActiveLoader(true);
        setLoaderText('uploading');

        if (validateForm()) {
            const trimmmedTitle = title.trim();
            if(image.name){
                const imageUrl = await uploadProductImageToSpace(image);
                addMilestone(dispatch, { title: trimmmedTitle, status: isActive, milestoneImage : imageUrl, description : description });
            } else{
                addMilestone(dispatch, { title: trimmmedTitle, status: isActive, description : description });
            }
        }
    }

    const hidePopup = () => {
        setActivePopup(false);
    }

    if (activePopup) {
        return (
            <Popup status={popupStatus} message={popupText} onClickAction={hidePopup} />
        )
    }

    return (
        <div className='container'>
            <div className="row">
                <div className="col-12">
                    <div className="discountCardWrapper">
                        <div className="discountHeader">
                            <h2>New Milestone</h2>
                        </div>
                        <div className="discountMiddleWrapper pt-2">
                            <div className="row gy-3">
                                <div className="col-12">
                                    <div className="discountInputFieldWrapper">
                                        <label>Enter Title</label>
                                        <div className="dicountInfoWrapper">
                                            <input type="text" value={title} onChange={handleTitleChange} placeholder="Title" />
                                            {
                                                titleError && (
                                                    <p className='error-text text-danger'>{titleErrorMessage}</p>
                                                )
                                            }
                                            <span className='error-text'>{errors.title}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="discountInputFieldWrapper">
                                        <label>Image</label>
                                        <div className="dicountInfoWrapper">
                                            <input type="file" name='file' className='newUserInput' onChange={(e) => setImage(e.target.files[0])} placeholder='Image' />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="discountInputFieldWrapper">
                                        <label>Description</label>
                                        <div className="dicountInfoWrapper">
                                            <textarea name="description" onChange={(e) => setDescription(e.target.value)}>
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="discountInputFieldWrapper">
                                        <label>Status</label>
                                        <div className="dicountInfoWrapper">
                                            <select name="status" value={isActive} onChange={(e) => setIsActive(e.target.value)}>
                                                <option value="true">Active</option>
                                                <option value="false">Inactive</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="discountSubmitBtnWrapper">
                                        <button className='custom-btn btn' onClick={handleSection}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                activeLoader && (
                    <CircleLoader title={loaderText} />
                )
            }
        </div>
    )
}

export default NewMilestone
